export default __webpack_public_path__ + "static/media/Shopify-Storefront---1.3b662f93.jpg";